import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import phone from "../../../images/phone.svg";
import {
  CreateParticularCustomertForm,
  EditParticularCustomertForm,
  CreateParticularCaseForm,
  EditParticularCaseForm,
} from "../../common/Forms/Form";
import { Select } from "../../common/Forms/Input/Input";
import { capitalize, exists } from "../../../assets/helpers/funciones";
import moment from "moment/moment";
import { PlanStatus } from "../../common/Cards/Cards";
import searchImg from "../../../images/search.svg";
import { ServiceButton } from "./IndicenceButtons";
import { serviceHistoryTableheader } from "../../../assets/helpers/tables";
import { IncidenceTable } from "../../common/Tables/Tables";
import { ActionButton, AltButton } from "../../common/Buttons/Buttons";
import {
  afiliatedServices,
  particularServices,
  clientTypes,
  planStatus,
  membershipCodes,
  NO_RECOMMENDED_PROVIDER,
} from "../../../assets/helpers/options";
import { SelectProvider } from "../../common/Forms/Input/Input.jsx";
import {
  notFound,
  lastServiceEnum,
  setviceType,
  towReasonsOptions,
} from "../../../assets/helpers/options";

import "./Incidence.scss";
import { membershipService } from "../../../services/membershipService.js";
import { notify } from "../../../assets/helpers/toast.js";
import { towReasons, userStatus } from "../../../assets/helpers/options.js";

export const ClientDetailSectionForm = (props) => {
  const {
    t,
    register,
    errors,
    onSubmit,
    options,
    type,
    onChange,
    getValues,
    watch,
    onPasteTemplate,
    control,
  } = props;
  return (
    <>
      <div className="light-gray-line"></div>
      <div className="buttons-container">
        <div>
          <h6>DETALLE DEL CLIENTE</h6>
          <p>(*) Campos obligatorios</p>
        </div>
        {type === notFound && typeof onPasteTemplate === "function" && (
          <AltButton label={"📋 Pegar plantilla"} action={onPasteTemplate} />
        )}
      </div>
      {type === notFound ? (
        <CreateParticularCustomertForm
          t={t}
          register={register}
          errors={errors}
          action={onSubmit}
          options={options}
          onChange={onChange}
          getValues={getValues}
          watch={watch}
          control={control}
        />
      ) : (
        <EditParticularCustomertForm
          t={t}
          register={register}
          errors={errors}
          action={onSubmit}
          options={options}
          onChange={onChange}
          watch={watch}
          control={control}
        />
      )}
    </>
  );
};

export const KmComponent = () => { };

export const AllyDetail = (props) => {
  const { membership } = props;

  return (
    <>
      <div className="filter-button-container"></div>
      <div className="buttons-container">
        <h6>DETALLE DEL ALIADO</h6>
        {membership?.status && (
          <PlanStatus label={membership?.status} membership={membership} />
        )}
      </div>
      <div className="row">
        <div className="col-12 col-lg-6 col-xl-4">
          <p>
            <b>{membership?.enterprise?.name?.toUpperCase()}</b>
            <br />
            {capitalize(membership?.firstName) +
              " " +
              capitalize(membership?.lastName)}
            <br />
            <>
              {exists(membership?.identificationType) +
                "-" +
                exists(membership?.identification)}
            </>
            <br />
          </p>
        </div>
      </div>
    </>
  );
};

export const ClientDetail = (props) => {
  const { membership, _case } = props;
  const [isLoading, setIsLoading] = useState(false);

  const handleSendDocuments = () => {
    setIsLoading(true);
    membershipService
      .sendDocuments(membership?._id)
      .then((response) => {
        if ([200, 201].includes(response.status)) {
          notify(`Documentos enviados con éxito`, "success");
          setIsLoading(false);
        } else {
          notify(`${response.message}`, "error");
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  return (
    <>
      <div className="filter-button-container"></div>
      <div className="buttons-container">
        <h6>DETALLE DEL CLIENTE</h6>
        {(membership?.status?.membershipStatus || (membership?.papClient)) && (
          <PlanStatus
            label={membership?.papClient ? membership?.status : membership?.status?.membershipStatus}
            membership={membership}
          />
        )}
      </div>
      <div className="row">
        <div className="col-12 col-lg-6 col-xl-4">
          <p>
            <b>Datos del Cliente :</b>
            <br />
            {capitalize(
              membership?.customer?.firstName ||
              _case?.particularCustomer?.firstName ||
              membership?.papClient?.firstName
            ) +
              " " +
              capitalize(
                membership?.customer?.lastName ||
                _case?.particularCustomer?.lastName ||
                membership?.papClient?.lastName
              )}
            <br />
            <>
              {exists(
                membership?.customer?.phonePrefix ||
                _case?.particularCustomer?.phonePrefix ||
                membership?.papClient?.phonePrefix
              ) +
                "-" +
                exists(
                  membership?.customer?.phoneNumber ||
                  _case?.particularCustomer?.phoneNumber ||
                  membership?.papClient?.phoneNumber
                )}
            </>
            <br />
            {membership?.customer?.prefixIdentification || membership?.papClient?.identificationType ? (
              <>
                {exists(membership?.customer?.prefixIdentification || membership?.papClient?.identificationType)}
                {exists(membership?.customer?.identification || membership?.papClient?.identification)} <br />
              </>
            ) : (
              <></>
            )}
            {membership?.code?.code ? (
              <>
                <b>
                  Plan:{" "}
                  {exists(
                    [membershipCodes.GOLDM].includes(membership?.code?.code)
                      ? capitalize(membershipCodes.GOLD)
                      : capitalize(membership?.code?.code)
                  )}
                </b>{" "}
                <br /> N° Producto:
                {" " +
                  exists(membership?.code?.prefixCode) +
                  "-" +
                  exists(membership?.saleChannel?.shortName) +
                  "-" +
                  exists(membership?.membershipId)}
                <br /> <b>Vigencia:</b>{" "}
                {membership?.beginDate &&
                  moment(membership?.beginDate).format("DD/MM/YYYY") + " al "}
                {membership?.endDate &&
                  moment(membership?.endDate).format("DD/MM/YYYY")}
                {membership?.towKM && (
                  <>
                    <br /> <b>Km permitidos: </b>
                    {`${membership?.towKM}${membership?.hasExtendedTowServiceAvailable
                      ? " + Servicio de Grúa extendido"
                      : ""
                      }`}
                  </>
                )}
              </>
            ) : (
              <b>{!membership?.papClient && "Cliente No Registrado"}</b>
            )}
            {membership?.papClient && (
              <>
                <b>Plan de Asistencia Primaria</b>
                <br />
                N° Producto: {membership?.startDate ? moment(membership?.startDate).format("DD/MM/YYYY") : ""} - {membership?.endDate ? moment(membership?.endDate).format("DD/MM/YYYY") : ""}
                <br />
                Vigencia: {membership?.startDate ? moment(membership?.startDate).format("DD/MM/YYYY") : ""} - {membership?.endDate ? moment(membership?.endDate).format("DD/MM/YYYY") : ""}
              </>
            )}

            <br />
            {membership?.affiliationType && (
              <>
                {" "}
                <b>Tipo de Afiliación: </b>
                {exists(membership?.affiliationType)}
              </>
            )}

            <br />
          </p>
        </div>
        {!membership?.papClient && <>
          <div className="col-12 col-lg-6 col-xl-4">
            <p>
              <b>Datos del Vehiculo :</b>
              <ul>
                {membership?.vehicle?.class && (
                  <li>Clase: {capitalize(membership?.vehicle?.class)}</li>
                )}
                {membership?.vehicle?.type && (
                  <li>Tipo: {capitalize(membership?.vehicle?.type)}</li>
                )}
                <li>
                  Año:{" "}
                  {capitalize(
                    membership?.vehicle?.year ||
                    _case?.particularCustomer?.vehicleYear
                  )}{" "}
                </li>
                <li>
                  Modelo:{" "}
                  {capitalize(
                    membership?.vehicle?.model ||
                    _case?.particularCustomer?.vehicleModel?.model
                  )}
                </li>
                <li>
                  Marca:{" "}
                  {capitalize(
                    membership?.vehicle?.brand ||
                    _case?.particularCustomer?.vehicleBrand?.brand
                  )}
                </li>
                <li>
                  Color:{" "}
                  {capitalize(
                    membership?.vehicle?.color ||
                    _case?.particularCustomer?.vehicleColor
                  )}{" "}
                </li>
                <li>
                  Placa:{" "}
                  {exists(
                    membership?.vehicle?.plate ||
                    _case?.particularCustomer?.vehiclePlate
                  )}
                </li>
                {membership?.vehicle?.serial && (
                  <li>Serial: {exists(membership?.vehicle?.serial)} </li>
                )}
                {membership?.vehicle?.km > 0 && (
                  <li>Kilometraje: {membership?.vehicle?.km}&nbsp;Km </li>
                )}
                {membership?.vehicle?.seats && (
                  <li>Asientos: {exists(membership?.vehicle?.seats)}</li>
                )}
                <li>Blindaje: {membership?.vehicle?.armored ? "Si" : "No"}</li>
                {membership?.vehicle?.armored && (
                  <li>Tipo de Blindaje: {membership?.vehicle?.armorType}</li>
                )}
                {/* <li>Blindaje: {exists(membership?.vehicle?.serial)} NO</li> */}
              </ul>
            </p>
          </div>
          <div className="col-12 col-lg-6 col-xl-4">
            <p>
              <b>Dirección asociada al vehiculo:</b>
              <br />
              <ul>
                <li>
                  <b>Estado:</b> {capitalize(membership?.vehicle?.state)}
                </li>
                <li>
                  <b>Ciudad:</b> {capitalize(membership?.vehicle?.city)}{" "}
                  {capitalize(membership?.vehicle?.city)}
                </li>

                <li>
                  {capitalize(membership?.vehicle?.municipality) + "  "}
                  {capitalize(membership?.vehicle?.address) +
                    " " +
                    capitalize(membership?.vehicle?.addressReference)}
                </li>
              </ul>
            </p>
          </div>
        </>}
        <div className="col-12" style={{ marginBottom: "12px" }}>
          {[
            planStatus.ACTIVE,
            planStatus.WAITING,
            planStatus.TO_BE_RENEW,
          ].includes(membership?.status.membershipStatus) && (
              <div>
                <div>
                  <p>{membership?.customer?.email.toLowerCase()}</p>
                  <ActionButton
                    label={"Reenviar Documentos"}
                    action={handleSendDocuments}
                  />
                </div>
              </div>
            )}
        </div>
      </div>
    </>
  );
};

export const OptionStatusColor = (props) => {
  const { status } = props;

  let color = "";
  let newLabel = status;

  if (["Activo", planStatus.ACTIVE, planStatus.TO_BE_RENEW].includes(status)) {
    color = "green";
    newLabel = "Activo";
  }
  if ([planStatus?.WAITING_TO_BE_EXPIRED].includes(status)) {
    color = "green";
    newLabel = "Esperando Vencimiento";
  }

  if (["Bloqueado"].includes(status)) {
    color = "red";
    newLabel = "Bloqueado";
  }

  if ([planStatus.EXPIRED, planStatus.TO_BE_EXPIRED].includes(status)) {
    color = "red";
    newLabel = "Vencido";
  }

  if ([planStatus.WAITING].includes(status)) {
    color = "gray";
    newLabel = status;
  }

  return (
    <span style={{ color: color }}>
      {" "}
      <b>{capitalize(newLabel)}</b>&nbsp; | &nbsp;{" "}
    </span>
  );
};

// Memoised row components. Each row is pure relative to its `option` and a
// stable `onSelect` callback, so once the search results land the rows skip
// re-rendering on subsequent parent updates (e.g. the user typing in another
// part of the form).

const AffiliatedOptionRow = React.memo(function AffiliatedOptionRow({
  option: o,
  onSelect,
}) {
  return (
    <div onClick={() => onSelect(o)}>
      <p>
        <OptionStatusColor status={o?.status} />
        {capitalize(
          o?.name || o?.papClient?.firstName + " " + o?.papClient?.lastName
        )}{" "}
        &nbsp; | &nbsp; CI:
        {o?.prefixIdentification || o?.papClient?.identificationType}-
        {o?.identification || o?.papClient?.identification}&nbsp; | &nbsp;{" "}
        {[membershipCodes.GOLDM].includes(o?.code)
          ? capitalize(membershipCodes.GOLD)
          : capitalize(o?.code)}
        &nbsp; | &nbsp;
        {capitalize(o?.brand)} {capitalize(o?.model)} {capitalize(o?.color)}{" "}
        {o?.plate}
        {o?.papClient ? (
          <span style={{ color: "green" }}>
            <b>{"PAP"}</b>
          </span>
        ) : (
          ""
        )}
      </p>
    </div>
  );
});

const AllyOptionRow = React.memo(function AllyOptionRow({
  option: o,
  onSelect,
}) {
  return (
    <div onClick={() => onSelect(o)}>
      <p>
        <OptionStatusColor status={o?.status} />
        {capitalize(o?.enterprise?.name)} &nbsp; | &nbsp;
        {o?.identificationType}-{o?.identification}&nbsp; | &nbsp;
        {capitalize(o?.firstName)} {capitalize(o?.lastName)}{" "}
      </p>
    </div>
  );
});

const ParticularOptionRow = React.memo(function ParticularOptionRow({
  option: o,
  onSelect,
}) {
  return (
    <div onClick={() => onSelect(o)}>
      <p>
        {exists(o?.vehiclePlate)} &nbsp;|&nbsp;
        {capitalize(o?.firstName)} &nbsp;
        {capitalize(o?.lastName)}&nbsp;|&nbsp;
        {capitalize(o?.vehicleBrand?.brand)}&nbsp;
        {capitalize(o?.vehicleModel?.model)}&nbsp;
        {capitalize(o?.vehicleYear)}&nbsp;
        {capitalize(o?.vehicleColor)}&nbsp;
      </p>
    </div>
  );
});

const IncidenceSearchInner = (props) => {
  const { clientSearch, onChange, search, selectClient, type, onPasteTemplate } =
    props;

  // Stabilise the callbacks through refs so the memoised rows below — and the
  // useMemo'd dropdown list — don't get invalidated each render just because
  // the parent recreated the handler.
  const onChangeRef = useRef(onChange);
  const searchRef = useRef(search);
  const selectClientRef = useRef(selectClient);
  const onPasteRef = useRef(onPasteTemplate);
  useEffect(() => {
    onChangeRef.current = onChange;
    searchRef.current = search;
    selectClientRef.current = selectClient;
    onPasteRef.current = onPasteTemplate;
  });

  const handleChange = useCallback((e) => onChangeRef.current?.(e), []);
  const handleSelect = useCallback((o) => selectClientRef.current?.(o), []);
  const handlePaste = useCallback(() => onPasteRef.current?.(), []);

  const searchParam = clientSearch?.searchParam;
  const handleSearch = useCallback(
    () => searchRef.current?.(searchParam),
    [searchParam]
  );
  const handleKeyDown = useCallback(
    (event) => {
      if (event.key === "Enter") searchRef.current?.(searchParam);
    },
    [searchParam]
  );

  const options = clientSearch?.options;
  const isOpen = clientSearch?.isOpen;

  // Build the rows only when the options array (or type) actually changes.
  // Without this useMemo the list would re-render on every parent update —
  // including every keystroke in the search input.
  const optionRows = useMemo(() => {
    if (!options) return null;
    if (options.length === 0) {
      return (
        <div
          onClick={
            type === clientTypes.PARTICULAR
              ? () => handleSelect()
              : undefined
          }
        >
          <h6>
            No se encuentra ningún registro.{" "}
            {type === clientTypes.PARTICULAR &&
              "Haga click aqui para introducir los datos del cliente"}
          </h6>
        </div>
      );
    }
    if (type === clientTypes.AFFILIATED) {
      return options.map((o) => (
        <AffiliatedOptionRow key={o?._id} option={o} onSelect={handleSelect} />
      ));
    }
    if (type === clientTypes.ALLY) {
      return options.map((o) => (
        <AllyOptionRow key={o?._id} option={o} onSelect={handleSelect} />
      ));
    }
    if (type === clientTypes.PARTICULAR) {
      return options.map((o) => (
        <ParticularOptionRow key={o?._id} option={o} onSelect={handleSelect} />
      ));
    }
    return null;
  }, [options, type, handleSelect]);

  return (
    <div className="incidence-search-container">
      <div className="buttons-container">
        <h6>
          BUSQUEDA DEL CLIENTE{" "}
          {type === clientTypes.ALLY ? " (Número de cédula o nombre)" : ""}
        </h6>
      </div>
      <div className="incidence-search">
        <div className="searchImageContainers">
          <img src={searchImg} alt="search" onClick={handleSearch} />
        </div>
        <input
          name={"searchParam"}
          value={searchParam}
          type="text"
          placeholder="Busqueda"
          onChange={handleChange}
          onKeyDown={handleKeyDown}
        />
        <ActionButton action={handleSearch} label={"Buscar"} />
        {typeof onPasteTemplate === "function" && (
          <AltButton label={"📋 Pegar plantilla"} action={handlePaste} />
        )}
        {isOpen && (
          <div className="incidence-search-options-container">{optionRows}</div>
        )}
      </div>

      {type === clientTypes.AFFILIATED && (
        <p>Campos de búsqueda: (Nombre, Apellido, Placa, Identificación)</p>
      )}
      {type === clientTypes.PARTICULAR && (
        <p>Campos de búsqueda: (Placa del Vehículo)</p>
      )}
      {type === clientTypes.ALLY && <p>Campos de búsqueda: (Cédula o Nombre)</p>}
    </div>
  );
};

export const IncidenceSearch = React.memo(IncidenceSearchInner);

export const AvailableServices = (props) => {
  const { availableServices, selectService, _case } = props;

  let lastService = "";

  if (_case) {
    [lastService] = _case?.services?.slice(-1);
  }

  let filteredServices = [...availableServices?.available];

  if (lastService?.type === lastServiceEnum?.CRANE) {
    filteredServices = availableServices?.available?.filter(
      (s) => s.type === setviceType?.CRANE
    );
  }

  if (lastService?.type === lastServiceEnum?.ROAD_ATTENDANT) {
    filteredServices = availableServices?.available?.filter(
      (s) => s.type === setviceType?.ROAD_ATTENDANT
    );
  }

  // Luego de un servicio de cerrajeria no se permite seleccionar grua
  const hasLocksmithService = _case?.services?.some((s) =>
    [s?.productCode, s?.product?.code].includes(afiliatedServices?.LOCKSMITH)
  );
  if (hasLocksmithService) {
    filteredServices = filteredServices?.filter(
      (s) =>
        ![
          afiliatedServices.crane,
          afiliatedServices.craneExtended,
          particularServices.crane,
        ].includes(s?.code)
    );
  }

  // aqui filtrar por tipos de servicios dependiendo dlete si el ultimo servicio del caso es de grua o de AV

  return (
    <>
      <div className="light-gray-line"></div>
      <div className="buttons-container">
        <h6>SERVICIOS DISPONIBLES</h6>
      </div>
      <div className="service-avaliable-options-container">
        {filteredServices?.length > 0 &&
          filteredServices?.map((s) => {
            if (!s.selected) {
              return (
                <ServiceButton
                  key={s._id}
                  selectService={selectService}
                  service={s}
                />
              );
            }
          })}
        {filteredServices?.length === 0 && (
          <h6 style={{ textAlign: "center", width: "100%" }}>
            No posee servicios disponibles
          </h6>
        )}
      </div>
    </>
  );
};

const SelectionReason = (props) => {
  const { name, options, label, value, onChange } = props;

  return (
    <Select
      name={name}
      options={options}
      label={label}
      value={value}
      onChange={onChange}
    />
  );
};

const isChangeService = (_case) => {
  if (_case?.services?.length > 0) {
    return false;
  } else return true;
};
export const SelectedServices = (props) => {
  const {
    providersOptions,
    unSelectService,
    availableServices,
    value,
    onChange,
    openSMSModal,
    openSMSTowModal,
    _case,
    reason,
    handleReason,
    clientType,
    recommendedProvidersOptions,
  } = props;

  const isLocksmith =
    availableServices?.selected?.code === afiliatedServices?.LOCKSMITH;

  return (
    <>
      <br />
      <div className="light-gray-line"></div>
      <div className="buttons-container">
        <h6>SERVICIO SELECCIONADO</h6>
      </div>
      <div className="selected-service-container">
        {availableServices?.available?.map((s) => {
          if (s.selected) {
            return (
              <div className="col-12 col-md-4" key={s._id}>
                <ServiceButton selectService={unSelectService} service={s} />
              </div>
            );
          }
        })}

        {![
          afiliatedServices.crane,
          afiliatedServices.craneExtended,
          particularServices.crane,
        ].includes(availableServices?.selected?.code) &&
          isChangeService(_case) ? (
          availableServices?.selected?.code &&
          availableServices?.selected?.code !==
          afiliatedServices?.SEG_VIAJE && (
            <SelectProvider
              bootstrap={"col-12 col-md-4"}
              label={
                isLocksmith
                  ? "Elegir Proveedor Recomendado:"
                  : "Elegir Motorizado:"
              }
              type={"select"}
              options={
                isLocksmith ? recommendedProvidersOptions : providersOptions
              }
              name={isLocksmith ? "recommendedProvider" : "motorizado"}
              placeholder={"Seleccione"}
              value={value}
              onChange={onChange}
              hideStatus={isLocksmith}
              noProviderLabel={
                isLocksmith ? "Sin proveedor recomendado" : undefined
              }
            />
          )
        ) : (
          <div className="col-12 col-md-4">
            {(clientType === clientTypes.AFFILIATED || _case?.membership) && (
              <SelectionReason
                onChange={handleReason}
                name={"reason"}
                value={reason}
                label={"Motivo de selección de la grúa"}
                options={towReasonsOptions.filter(o => o.name !== towReasons?.EXTERNAL_TOW_PRIORITY)}
              />
            )}
          </div>
        )}

        <div className="col-12 col-md-4 sms-button-logo-container">
          {value && isChangeService(_case) && (
            <img
              className="sms-button-logo"
              src={phone}
              alt="phone"
              onClick={() => openSMSModal()}
            />
          )}
          {[afiliatedServices.crane, particularServices.crane].includes(
            availableServices?.selected?.code
          ) &&
            isChangeService(_case) && (
              <img
                className="sms-button-logo"
                src={phone}
                alt="phone"
                onClick={() => openSMSTowModal()}
              />
            )}
        </div>
      </div>
    </>
  );
};

export const HandleCaseButtons = (props) => {
  const {
    setShowSchedule,
    handleScheduleBattery,
    service,
    selectedBike,
    handleCancelService,
    _case,
    openModals,
    bikerData,
    otpBlocked,
  } = props;

  // Los motorizados traen isActive boolean y los proveedores de cerrajeria "Activo"/"Inactivo"
  // Cerrajeria puede registrarse sin proveedor recomendado
  const isProviderActive =
    selectedBike === NO_RECOMMENDED_PROVIDER ||
    bikerData?.isActive === true ||
    bikerData?.isActive === userStatus?.ACTIVE;

  const handleRegisterButton = (_case) => {
    if ([afiliatedServices.BATT_SALE, particularServices.BATT_SALE_PART].includes(service?.code)) {
      return (
        <ActionButton
          label={"Iniciar"}
          action={() => openModals.handleBatterySaleModal()}
          disabled={!isProviderActive}
        />
      )
    } else {
      return (
        <ActionButton
          label={"Registrar Pago"}
          action={() => openModals.openSMSModal()}
          disabled={!isProviderActive}
        />
      )
    }
  }
  return (
    <div
      className="buttons-center-container"
      style={{ margin: "0px 0px 48px 0px" }}
    >
      <AltButton
        label={"Cancelar Servicio"}
        action={() => handleCancelService(_case)}
      />

      {[
        afiliatedServices.crane,
        afiliatedServices?.craneExtended,
        particularServices.crane,
      ].includes(service?.code) &&
        isChangeService(_case) && (
          <AltButton
            label={"Agendar servicio"}
            action={() => setShowSchedule({
              battery: false,
              show: true
            })}
          />
        )}
      {![
        afiliatedServices.crane,
        afiliatedServices?.craneExtended,
        particularServices.crane,
        afiliatedServices?.LOCKSMITH,
      ].includes(service?.code) &&
        isChangeService(_case) &&
        selectedBike && (
          <AltButton
            label={"Agendar servicio"}
            action={() => handleScheduleBattery(service?.code)}
          />
        )}

      {service?.code === afiliatedServices?.SEG_VIAJE && (
        <AltButton
          label={"Parametros"}
          action={() => openModals?.openFollowUpModal()}
        />
      )}
      {[
        afiliatedServices.crane,
        particularServices.crane,
        afiliatedServices?.craneExtended,
      ].includes(service?.code) &&
        isChangeService(_case) && (
          <ActionButton
            label={"Iniciar"}
            action={() => openModals.openSMSTowModal()}
            disabled={otpBlocked}
          />
        )}
      {!isChangeService(_case) && (
        <ActionButton
          label={"Editar Servicio"}
          action={() => openModals.handleEditService(_case)}
        />
      )}
      {selectedBike &&
        isChangeService(_case) &&
        handleRegisterButton(_case)}
    </div>
  );
};

export const IncidenceDetailForm = (props) => {
  const {
    register,
    errors,
    onChange,
    options,
    watch,
    openMapModal,
    _case,
    createCase,
    editCase,
    disabled,
    clientSearch,
    suggestion,
    clientType,
    setValue,
    control,
    lockWithOutDestinyAddress,
  } = props;

  return (
    <>
      <div className="light-gray-line"></div>
      <div className="filter-button-container"></div>
      <div className="buttons-container">
        <div>
          <h6>DETALLES DE LA INCIDENCIA</h6>
          <p>(*) Campos obligatorios</p>
        </div>
      </div>
      {!_case ? (
        <CreateParticularCaseForm
          register={register}
          handleSubmit={createCase}
          errors={errors}
          onChange={onChange}
          options={options}
          watch={watch}
          openMapModal={openMapModal}
          _case={_case}
          clientSearch={clientSearch}
          suggestion={suggestion}
          clientType={clientType}
          setValue={setValue}
          control={control}
        />
      ) : (
        <EditParticularCaseForm
          register={register}
          handleSubmit={editCase}
          errors={errors}
          onChange={onChange}
          options={options}
          watch={watch}
          openMapModal={openMapModal}
          _case={_case}
          disabled={disabled}
          clientSearch={clientSearch}
          suggestion={suggestion}
          clientType={clientType}
          control={control}
          lockWithOutDestinyAddress={lockWithOutDestinyAddress}
        />
      )}
    </>
  );
};

export const ServiceHistory = (props) => {
  const { serviceHistory } = props;

  return (
    <>
      <br />
      <div className="light-gray-line"></div>
      <IncidenceTable
        title={"HISTORIAL DE SERVICIOS"}
        header={serviceHistoryTableheader}
        data={serviceHistory}
      />
    </>
  );
};

export const CaseDetail = (props) => {
  const { title, selectedCase } = props;
  return (
    <div className="incidence-table-section-container">
      <div className="filter-button-container"></div>
      <div className="buttons-container">
        <h6>{title}</h6>
      </div>
      <div className="row">
        <div className="col-12 col-lg-6 col-xl-4">
          <p>
            <b>Avería: </b> {selectedCase?.fault?.description} <br />
            <b>Caso Nro: </b> {selectedCase?.caseId}
            <br />
            {/* <b>Código de servicio: </b> CCCT15-0024435 */}
            <b>Operador: </b>
            {selectedCase?.user?.firstName} {selectedCase?.user?.lastName}
          </p>
        </div>
      </div>
    </div>
  );
};
